import { routesDef } from '../../../config/routes'

type MenuItemType = {
  slug: string
  label: string
  icon: string
  url: string
  children?: MenuItemType[]
}

export const menuItems: MenuItemType[] = [
  { slug: 'overview', label: 'Overview', icon: 'gauge', url: routesDef.OverviewPage.path },
  { slug: 'tickets', label: 'Tickets', icon: 'ticket', url: routesDef.TicketListPage.path },
  { slug: 'customers', label: 'Customers', icon: 'users', url: routesDef.CustomerListPage.path },
  { slug: 'drivers', label: 'Drivers', icon: 'truck', url: routesDef.DriverListPage.path },
  { slug: 'routes', label: 'Routes', icon: 'route', url: routesDef.RouteListPage.path },
  { slug: 'settings', label: 'Settings', icon: 'cog', url: routesDef.SettingsPage.path },
]
